var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.teks)?_c('div',{staticClass:"caption font-italic grey--text text--darken-1"},[_vm._v(" "+_vm._s(_vm.teks)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }